import {
  SignIn,
  SignUp,
  BackendLogout,
  ChangePassword,
  ConfirmSignUp,
  // ConfirmEmail,
  ForgotPassword,
  ResetPassword,
} from './auth.actions';

export const AuthLoadingActions = [
  SignIn,
  SignUp,
  BackendLogout,
  ChangePassword,
  ConfirmSignUp,
  // ConfirmEmail,
  ForgotPassword,
  ResetPassword,
];
